export default __webpack_public_path__ + "static/media/review-person-3.34a36da9.png";